<template>
  <div>
    <v-overlay :value="loading" :absolute="true">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>
    <DriverOOReportTemplate v-if="$route.name === 'reportPrint'"
                           :entries="loads"
                           :totalsCounts="totalsCounts"
                           :from="from"
                           :to="to"
                           :driverName="driverName"
                           :isWithNet="$root.isAccessRightAllowView($store.getters.loadsRights['financialInformation']) ? isWithNet : false"
                           :key="'reportTemplateKey' + loads.length"
                           :companyId="companyId"
    />
    <v-card v-else>
      <v-card-title>{{driverName}}</v-card-title>
      <v-layout v-if="driverId > 0">
        <v-flex xs12>
          <v-card class="ma-2">
            <ReportsGroupsList :type="$route.params.type" :userId="driverId" :totalsCountsNames="totalsCountsNames" :totalsCounts="totalsCounts" :key="reportsGroupsListKey"></ReportsGroupsList>
          </v-card>
        </v-flex>
      </v-layout>
      <v-switch
        v-if="$root.isAccessRightAllowView($store.getters.loadsRights['financialInformation'])"
        v-model="isWithNet"
        :label="$t('Reports.viewFullInfoForDriverOOSwitch')"
        @change="onViewAsDriverOO"
      ></v-switch>
      <v-layout wrap>
        <v-flex xs12 md6>
          <v-simple-table dense class="mb-5">
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="text-left" colspan="2">
                    <h1>Totals</h1>
                  </th>
                </tr>
                <tr>
                  <td class="text-left">Loads Count</td>
                  <td class="text-left">{{totalsCounts.loads.toLocaleString()}}</td>
                </tr>
                <tr>
                  <td class="text-left">Total Miles</td>
                  <td class="text-left">{{totalsCounts.totalMiles.toLocaleString()}} {{$t('milesShort')}}</td>
                </tr>
                <tr v-if="isWithNet && totalsCounts.totalInitialRate && $root.isAccessRightAllowView($store.getters.loadsRights['financialInformation'])">
                  <td class="text-left">Total Initial Rate</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalInitialRate.toFixed(2)).toLocaleString()}}</td>
                </tr>
                <tr v-if="isWithNet && totalsCounts.totalRateBonus && $root.isAccessRightAllowView($store.getters.loadsRights['financialInformation'])">
                  <td class="text-left">Total Bonus</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalRateBonus.toFixed(2)).toLocaleString()}}</td>
                </tr>
                <tr v-if="totalsCounts.totalRate">
                  <td class="text-left">Total Rate</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalRate.toFixed(2)).toLocaleString()}}</td>
                </tr>
                <tr>
                  <td class="text-left">Avg Fees Percent</td>
                  <td class="text-left">{{totalsCounts.avgFeesPercent}}%</td>
                </tr>
                <tr v-if="totalsCounts.totalFees">
                  <td class="text-left">Total Fees Amount</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalFees.toFixed(2)).toLocaleString()}}</td>
                </tr>
                <tr v-if="totalsCounts.totalAdditionalPayments">
                  <td class="text-left">Total Additional Payments</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalAdditionalPayments.toFixed(2)).toLocaleString()}}</td>
                </tr>
                <tr v-if="totalsCounts.totalSalary">
                  <td class="text-left">Total Salary</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalSalary.toFixed(2)).toLocaleString()}}</td>
                </tr>
                <tr v-if="totalsCounts.totalPaidSalary">
                  <td class="text-left">Total Paid Salary</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalPaidSalary.toFixed(2)).toLocaleString()}}</td>
                </tr>
                <tr v-if="totalsCounts.totalSalary && totalsCounts.totalPaidSalary">
                  <td class="text-left">Total Not Paid Salary</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(parseFloat(totalsCounts.totalSalary-totalsCounts.totalPaidSalary).toFixed(2)).toLocaleString()}}</td>
                </tr>
                <tr v-if="isWithNet && totalsCounts.totalExpenses && $root.isAccessRightAllowView($store.getters.loadsRights['financialInformation'])">
                  <td class="text-left">Total Expenses</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalExpenses.toFixed(2)).toLocaleString()}}</td>
                </tr>
                <tr v-if="isWithNet && totalsCounts.totalNet && $root.isAccessRightAllowView($store.getters.loadsRights['financialInformation'])">
                  <td class="text-left">Total Net</td>
                  <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalNet.toFixed(2)).toLocaleString()}}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
      </v-layout>

      <v-card-title>
        <h2>Driver Owner-Operator Loads</h2>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <!--<v-layout v-if="$root.isFullFinancialDataAllowedToView && driverId > 0">
        <v-flex xs12 class="text-right">
          <ReportActions
            :selectedItems="selectedItems"
            :lastReportsGroupNumber="lastReportsGroupNumber"
            :userId="driverId"
            :type="$route.params.type"
            :from="from"
            :to="to"
            :isSelectedHaveNotPayed="isSelectedHaveNotPayed"
            :isSelectedHavePayed="isSelectedHavePayed"
            @paidDTChangeMulti="$emit('paidDTChangeMulti', selectedItems, driverId, selectedItems[0].payedDateTime)"
            @markSelectedAsPayedAndCreateReportGroup="markSelectedAsPayedAndCreateReportGroup"
            @markSelectedAsPayed="markSelectedAsPayed"
            @markSelectedAsNotPayed="markSelectedAsNotPayed"
            @createReportGroup="createReportGroup"
          />
        </v-flex>
      </v-layout>-->

      <!--<hr/>
      {{loads}}
      <hr/>-->
      <v-data-table
        :headers="headers"
        :items="loads"
        :search="search"
        :items-per-page="100"
        :footer-props="footer_props"
        v-model="selectedItems"
        show-select
        @item-selected="onItemSelected"
        @toggle-select-all="onItemSelected"
        @click:row="$root.onShowLoadPreview($event.id)"
      >
        <template v-slot:item.status="{ item }">
          <div class="text-no-wrap">
            <v-icon v-if="item.status.phaseIcon" v-html="item.status.phaseIcon" :color="item.status.phaseColor" class="mr-1"></v-icon>
            <v-icon v-if="item.status.stageIcon" small v-html="item.status.stageIcon" :color="item.status.stageColor" class="mr-1"></v-icon>
            <v-icon v-if="item.isReturnToHQ === 1" color="success" class="mr-1">mdi-redo-variant</v-icon>
          </div>
        </template>

        <template v-slot:item.started="{ item }">
          <div class="text-no-wrap">{{item.startedPST}}</div>
          <div class="text-no-wrap">{{item.endedPST}}</div>
        </template>

        <template v-slot:item.uid_load_number="{ item }">
            <span class="text-no-wrap">
              {{item.loadNumber}}
              <v-btn v-if="item.loadNumber" small icon @click.stop="$root.copyToClipboard(item.loadNumber)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
          <br/>
          <span class="text-no-wrap">
              {{item.uid}}
              <v-btn v-if="item.uid" small icon @click.stop="$root.copyToClipboard(item.uid)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
        </template>

        <template v-slot:item.miles="{ item }">
          {{item.miles.toLocaleString()}}&nbsp;{{$t('milesShort')}}
        </template>

        <template v-slot:item.drivers_trucks="{ item }">
          <TruckDriversSnippet :isDriverOO="true" :truckOO="item.truckOOData" :driverOO="item.driverOOData" :load-id="item.id"></TruckDriversSnippet>
        </template>

        <template v-slot:item.name="{ item }">
          <div class="text-no-wrap">
            {{item.name.split('--')[0]}}
          </div>
          <div class="text-no-wrap">
            {{item.name.split('--')[1]}}
          </div>
        </template>
        <template v-slot:item.rate="{ item }">
          <template v-if="isWithNet && $root.isAccessRightAllowView($store.getters.loadsRights['financialInformation'])">
            <!--<div style="white-space: nowrap;">{{parseFloat(item.initialRate.toFixed(2)).toLocaleString()}}-{{parseFloat(item.rateBonus.toFixed(2)).toLocaleString()}}=</div>-->
            <div style="white-space: nowrap;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on"><v-icon small class="mr-1">mdi-information</v-icon></v-btn>
                </template>
                <span>
                  <template v-if="item.finished === 2">
                    <b>{{$t('Loads.RateTONU')}}</b>: ${{item.RateTONU}}<br/>
                  </template>
                  <template v-if="item.initialRate">
                    <b>{{$t('Loads.Rate')}}</b>: ${{item.initialRate}}<br/>
                  </template>
                  <template v-if="item.rateBonus">
                    <b>{{$t('Loads.driverOwnerOperatorBonus')}}</b>: ${{item.rateBonus}}<br/>
                  </template>
                  <template v-for="additional_payment_item in ['Detention', 'Layover', 'Fine', 'DriverAssist', 'Idle']">
                    <template v-if="item[additional_payment_item]">
                      <b>{{$t('Loads.'+additional_payment_item)}}</b>: ${{item[additional_payment_item]}}<br/>
                    </template>
                  </template>
                </span>
              </v-tooltip>
              <v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(parseFloat(item.initialRate-item.rateBonus).toFixed(2)).toLocaleString()}}</div>
              <v-tooltip bottom v-if="item.isDriverAssist">
                <template v-slot:activator="{ on }">
                  <v-icon color="warning" v-on="on">mdi-weight-lifter</v-icon>
                </template>
                <span>{{$t('Loads.isDriverAssist')}}</span>
              </v-tooltip>
          </template>
          <template v-else>
            <span class="text-no-wrap"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{item.Rate.toLocaleString()}}</span>
          </template>
          <!--<template v-if="item.finished === 2"><v-chip color="warning" small>TONU</v-chip></template>-->
        </template>

        <template v-slot:item.fees="{ item }">
          <span class="ml-3">{{item.driverOwnerOperatorPercent}}%</span><br/>
          <span class="text-no-wrap"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(item.fees).toFixed(2).toLocaleString()}}</span>
        </template>

        <template v-slot:item.additional_paymens="{ item }">
          <span class="text-no-wrap"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{item.driverAdditionalPayments.toLocaleString()}}</span>
        </template>

        <template v-slot:item.salary="{ item }">
          <v-chip v-if="item.isPaid" class="ma-1" label small color="success">
            {{$t('Reports.Paid')}}
            <div class="text-no-wrap">&nbsp;${{item.driverSalary.toLocaleString()}}</div>
          </v-chip>
          <span v-else class="text-no-wrap"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{item.driverSalary.toLocaleString()}}</span>
          <br v-if="item.isPaid">
          <div class="text-no-wrap" v-if="item.isPaid">
            <label class="caption text-no-wrap">{{item.payedDateTime}}</label>
            <v-btn icon small @click.stop="$emit('paidDTChanged', item.id, driverId, item.payedDateTime)"><v-icon small>mdi-pencil</v-icon></v-btn>
          </div>
        </template>

        <template v-slot:item.net="{ item }">
          <span class="text-no-wrap"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{item.net.toLocaleString()}}</span>
        </template>

        <template v-slot:item.expenses="{ item }">
          <span class="text-no-wrap"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{item.expenses.toLocaleString()}}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-layout>
            <v-flex class="pa-0" v-for="invoiceItem in item.invoicesArray" :key="'inv'+invoiceItem.id">
              <template v-if="invoiceItem.invoiceReceivedDate > 0 && $root.isInvoicesViewAllowed">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" :color="$root.getInvoiceTypeColorByStatus(invoiceItem.invoiceStatus)" @click.stop="$root.route('/invoices/page/'+invoiceItem.invoiceId)"><v-icon small>fa-file-invoice-dollar</v-icon></v-btn>
                  </template>
                  <span>{{$t('Loads.Invoice')}} #{{invoiceItem.invoiceNumber}} ${{invoiceItem.invoiceTotal}}&nbsp;<strong>{{invoiceItem.invoiceStatus}}</strong></span>
                </v-tooltip>
              </template>
              <template v-else-if="!invoiceItem.invoiceReceivedDate && $root.isInvoicesViewAllowed">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" :color="invoiceItem.invoiceDueLeftSeconds < 0 ? 'red' : 'warning'" @click.stop="$root.route('/invoices/page/'+invoiceItem.invoiceId)"><v-icon small>fa-file-invoice-dollar</v-icon></v-btn>
                  </template>
                  <span v-if="invoiceItem.invoiceDueLeftSeconds < 0">{{$t('Loads.Invoice')}} #{{invoiceItem.invoiceNumber}} ${{invoiceItem.invoiceTotal}}&nbsp;{{$t('Invoices.Overdue')}}:&nbsp;-{{Math.ceil($root.secondsToHms(invoiceItem.invoiceDueLeftSeconds).hours / 24)}} d.</span>
                  <span v-if="invoiceItem.invoiceDueLeftSeconds > 0">{{$t('Loads.Invoice')}} #{{invoiceItem.invoiceNumber}} ${{invoiceItem.invoiceTotal}}&nbsp;{{$t('Invoices.DueDate')}}:&nbsp;+{{Math.ceil($root.secondsToHms(invoiceItem.invoiceDueLeftSeconds).hours / 24)}} d.</span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex v-if="item.invoicesArray.length === 0">
              <v-btn icon disabled><v-icon small class="mr-1">fa-file-invoice-dollar</v-icon></v-btn>
            </v-flex>
            <v-flex>
              <template v-if="item.bid">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click.stop="$root.route('/bids/'+item.bid)"><v-icon small class="mr-1">mdi-file-question</v-icon></v-btn>
                  </template>
                  <span>Bid #{{item.bid}}</span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex>
              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click.stop="onShowDocuments(item)"><v-icon small class="mr-1">mdi-file-multiple</v-icon></v-btn>
                  </template>
                  <span>{{$t('Loads.uploadDocuments')}}</span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex>
              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click.stop="onShowExpenses(item.expensesJSON, item.finished, item.id)">
                      <v-icon small class="mr-1" :color="item.isPendingExpenses ? 'warning' : 'success'">fa-coins</v-icon>
                    </v-btn>
                  </template>
                  <span>{{!item.isPendingExpenses ? $t('Loads.ExpensesTitle') : $t('Loads.ExpensesHasPending')}}</span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex v-if="driverId > 0">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="ma-1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="markAsPayed(item.id, driverId)">
                    <v-list-item-icon><v-icon color="success">mdi-currency-usd</v-icon></v-list-item-icon>
                    <v-list-item-title> Mark as Payed</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="markAsNotPayed(item.id, driverId)">
                    <v-list-item-icon><v-icon color="error">mdi-currency-usd-off</v-icon></v-list-item-icon>
                    <v-list-item-title> Mark as Not Payed</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>
        </template>

      </v-data-table>

      <!--<v-layout v-if="$root.isFullFinancialDataAllowedToView && driverId > 0">
        <v-flex xs12 class="text-right">
          <ReportActions
            :selectedItems="selectedItems"
            :lastReportsGroupNumber="lastReportsGroupNumber"
            :userId="driverId"
            :type="$route.params.type"
            :from="from"
            :to="to"
            :isSelectedHaveNotPayed="isSelectedHaveNotPayed"
            :isSelectedHavePayed="isSelectedHavePayed"
            @paidDTChangeMulti="$emit('paidDTChangeMulti', selectedItems, driverId, selectedItems[0].payedDateTime)"
            @markSelectedAsPayedAndCreateReportGroup="markSelectedAsPayedAndCreateReportGroup"
            @markSelectedAsPayed="markSelectedAsPayed"
            @markSelectedAsNotPayed="markSelectedAsNotPayed"
            @createReportGroup="createReportGroup"
          />
        </v-flex>
      </v-layout>-->

      <v-dialog v-model="expensesModal" scrollable max-width="1000px">
        <v-card>
          <v-card-title>
            <h2>{{$t('Loads.ExpensesTitle')}}</h2><v-spacer></v-spacer><v-btn icon @click="expensesModal=false;"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <LoadExpenses :key="expensesModalKey"
                        :expensesArray="selectedExpenses"
                        :readOnly="!$root.isLoadsEditAllowed"
                        :isFinished="selectedFinishedField !== 0"
                        :loadId="selectedExpensesLoadId"
                        @expensesSaved="fetchData()"
          ></LoadExpenses>
        </v-card>
      </v-dialog>
      <v-dialog v-model="documentsModal" scrollable>
        <v-card>
          <v-card-title>
            <h2>{{$t('Loads.uploadDocuments')}}</h2><v-spacer></v-spacer><v-btn icon @click="documentsModal=false;"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <LoadDocuments :key="documentsModalKey" :fields="selectedELoadFields" :readonly="true" :isDriverOO="isWithNet ? false : true"></LoadDocuments>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import LoadExpenses from '../../components/LoadExpenses.vue';
import LoadDocuments from '../../components/LoadDocuments.vue';
import DriverOOReportTemplate from '../../views/Reports/DriverOOReportTemplate.vue';
import ReportsGroupsList from './ReportsGroupsList.vue';
import TruckDriversSnippet from '../../components/TruckDriversSnippet';
import ReportActions from '../../components/ReportActions';

export default {
  name: 'DriverOOReport',
  props: ['from', 'to', 'driverId', 'driverName', 'selectedStr', 'companyId'],
  components: { TruckDriversSnippet, LoadExpenses, LoadDocuments, DriverOOReportTemplate, ReportsGroupsList, ReportActions },
  mixins: [reportsMixin],
  data: function () {
    return {
      loading: false,
      totalsCounts: {
        loads: 0,
        totalMiles: 0,
        totalRate: 0,
        avgFeesPercent: 0,
        totalFees: 0,
        totalAdditionalPayments: 0,
        totalSalary: 0,
        totalPaidSalary: 0,
        totalInitialRate: 0,
        totalRateBonus: 0,
        totalExpenses: 0,
        totalNet: 0
      },
      totalsCountsNames: {},
      loads: [],
      search: '',
      selectedItems: [],
      expensesModal: false,
      expensesModalKey: new Date().getTime(),
      selectedExpenses: [],
      selectedExpensesLoadId: 0,
      selectedFinishedField: 0,
      documentsModal: false,
      documentsModalKey: new Date().getTime(),
      selectedELoadFields: {},
      isWithNet: true,
      headers: [],
      footer_props: {
        'items-per-page-options': [10, 25, 50, 100],
        'items-per-page-text': '',
        'disable-items-per-page': false
      }
    };
  },
  computed: {

  },
  mounted () {
    this.$root.setLastListPath(this.$route.path);
    if (this.$root.getLocalStorageItem('viewFullDriverOOInfo')) {
      this.isWithNet = this.$root.getLocalStorageItem('viewFullDriverOOInfo') === 'true' && this.$root.isAccessRightAllowView(this.$store.getters.loadsRights['financialInformation']);
    }
    this.initHeaders();
    this.$nextTick(() => {
      this.fetchData();
      //this.updateLastReportsGroupNumber(this.driverId, this.$route.params.type);
    });
  },
  methods: {
    clearTotals () {
      this.totalsCounts = {
        loads: 0,
        totalMiles: 0,
        totalRate: 0,
        avgFeesPercent: 0,
        totalFees: 0,
        totalAdditionalPayments: 0,
        totalSalary: 0,
        totalPaidSalary: 0,
        totalInitialRate: 0,
        totalRateBonus: 0,
        totalExpenses: 0,
        totalNet: 0
      };
    },
    initHeaders () {
      if (this.isWithNet && this.$root.isAccessRightAllowView(this.$store.getters.loadsRights['financialInformation'])) {
        this.headers = [
          { text: '#', value: 'id' },
          { text: '', value: 'status' },
          { text: 'Started / Ended', value: 'started' },
          { text: 'Locations', value: 'name' },
          { text: 'Trucks / Drivers', value: 'drivers_trucks', sortable: false },
          { text: 'UID/Load Number', value: 'uid_load_number', sortable: false },
          { text: 'Load Rate', value: 'rate' },
          { text: 'Fees', value: 'fees' },
          { text: 'Additional', value: 'additional_paymens' },
          { text: 'Expenses', value: 'expenses' },
          { text: 'Net', value: 'net' },
          { text: 'Salary', value: 'salary' },
          { text: '', value: 'actions', sortable: false }
        ];
        this.totalsCountsNames = {
          loads: 'Loads',
          totalMiles: 'Miles',
          totalRate: 'Rate',
          totalFees: 'Fee',
          totalAdditionalPayments: 'Addtn.',
          totalSalary: 'Salary',
          totalPaidSalary: 'Paid',
          totalInitialRate: 'Initial Rate',
          totalRateBonus: 'Bonus',
          totalExpenses: 'Expen.',
          totalNet: 'Net'
        };
      } else {
        this.headers = [
          { text: '#', value: 'id' },
          { text: '', value: 'status' },
          { text: 'Started / Ended', value: 'started' },
          { text: 'Locations', value: 'name' },
          { text: 'Trucks / Drivers', value: 'drivers_trucks', sortable: false },
          { text: 'UID/Load Number', value: 'uid_load_number', sortable: false },
          { text: 'Load Rate', value: 'rate' },
          { text: 'Fees', value: 'fees' },
          { text: 'Additional', value: 'additional_paymens' },
          { text: 'Salary', value: 'salary' },
          { text: '', value: 'actions', sortable: false }
        ];
        this.totalsCountsNames = {
          loads: 'Loads',
          totalMiles: 'Miles',
          totalRate: 'Rate',
          totalFees: 'Fee',
          totalAdditionalPayments: 'Addtn.',
          totalSalary: 'Salary',
          totalPaidSalary: 'Paid'
        };
      }
    },
    onViewAsDriverOO (event) {
      this.$root.setLocalStorageItem('viewFullDriverOOInfo', event);
      this.initHeaders();
    },
    onItemSelected () {
      let i = 0;
      this.$nextTick(() => {
        let selected = [];
        for (i = 0; i < this.selectedItems.length; i++) {
          selected.push(parseInt(this.selectedItems[i]['id']));
        }
        this.$emit('selected', selected);
      });
    },
    onShowExpenses (expensesJSON, finishedField, loadId) {
      if (expensesJSON) {
        this.selectedExpensesLoadId = loadId;
        this.selectedExpenses = JSON.parse(expensesJSON);
        this.selectedFinishedField = finishedField;
        this.expensesModalKey = new Date().getTime();
        this.expensesModal = true;
      }
    },
    onShowDocuments (fields) {
      if (fields) {
        this.selectedELoadFields = fields;
        this.documentsModalKey = new Date().getTime();
        this.documentsModal = true;
      }
    },
    fetchData (skipSelected = false, selected = []) {
      if (!this.from || !this.to) return;
      return new Promise((resolve, reject) => {
        this.totalsCounts = {
          loads: 0,
          totalMiles: 0,
          totalRate: 0
        };
        this.loading = true;

        this.getLoadsReportData(this.from, this.to, 0, this.driverId, 0, true).then((response) => {
          let i = 0;
          let l = 0;
          let load = null;
          let sumOfFeesPercent = 0;
          let pickupLocationName = '';
          let deliveryLocationName = '';
          let locations = null;

          if (response.status === 'ok') {
            this.clearTotals();
            this.loads = [];

            let selectedArray = [];
            if (!skipSelected && this.selectedStr) {
              selectedArray = this.selectedStr.split(',').map(v => {
                return parseInt(v);
              });
            }
            else if (!skipSelected && selected.length > 0) {
              for (let i = 0; i < selected.length; i++) {
                selectedArray.push(selected[i]);
              }
            }
            this.selectedItems = [];

            for (i = 0; i < response.loads.length; i++) {
              load = response.loads[i];
              if (selectedArray.length > 0 && selectedArray.indexOf(parseInt(load.id)) < 0) continue;

              load.miles = parseInt(response.loads[i].distanceInMiles);
              load.rate = parseFloat(response.loads[i].Rate);

              this.totalsCounts.totalMiles += parseInt(response.loads[i].distanceInMiles);
              this.totalsCounts.totalRate += parseFloat(response.loads[i].Rate);
              if (response.loads[i].driverAdditionalPayments > 0) {
                this.totalsCounts.totalAdditionalPayments += parseFloat(response.loads[i].driverAdditionalPayments);
              }
              if (response.loads[i].driverSalary > 0) {
                this.totalsCounts.totalSalary += parseFloat(response.loads[i].driverSalary);
              }

              // locations = JSON.parse(response.loads[i].locationsJSON.replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t'));
              locations = response.loads[i].locations;
              load.status = this.$root.getLoadStatus(locations, response.loads[i].finished);

              for (l = 0; l < locations.length; l++) {
                if (locations[l].pickup) {
                  pickupLocationName = locations[l].name;
                  break;
                }
              }

              for (l = locations.length - 1; l >= 0; l--) {
                if (locations[l].delivery) {
                  deliveryLocationName = locations[l].name;
                  break;
                }
              }

              load.uid_load_number = load.loadNumber + ' ' + load.uid;
              load.drivers_trucks += ' ' + load.truckName + ' ' + load.driverName;

              pickupLocationName = pickupLocationName.replace(/, USA/gi, '');
              if (pickupLocationName.split(',').length > 2) {
                pickupLocationName = pickupLocationName.substring(pickupLocationName.indexOf(',') + 1);
              }
              deliveryLocationName = deliveryLocationName.replace(/, USA/gi, '');
              if (deliveryLocationName.split(',').length > 2) {
                deliveryLocationName = deliveryLocationName.substring(deliveryLocationName.indexOf(',') + 1);
              }

              load.name = pickupLocationName + ' -- ' + deliveryLocationName;

              load.isPaid = false;
              // Extract status
              if (load.reportsStatuses && load.reportsStatuses.indexOf('{') === 0) {
                const reportsStatusesObject = JSON.parse(load.reportsStatuses);
                load.isPaid = reportsStatusesObject.hasOwnProperty(this.driverId + '_payed');
                load.payedDateTime = reportsStatusesObject[this.driverId + '_payed'];
              }
              if (load.isPaid) {
                if (response.loads[i].driverSalary > 0) {
                  this.totalsCounts.totalPaidSalary += parseFloat(response.loads[i].driverSalary);
                }
              }
              load.fees = parseFloat(load.rate) * parseFloat(load.driverOwnerOperatorPercent / 100.0);
              sumOfFeesPercent += parseFloat(load.driverOwnerOperatorPercent);

              this.totalsCounts.totalFees += parseFloat(load.fees);

              // check and add full information
              if (load.net) {
                if (load.initialRate) {
                  this.totalsCounts.totalInitialRate += parseFloat(load.initialRate);
                }
                if (load.rateBonus) {
                  this.totalsCounts.totalRateBonus += parseFloat(load.rateBonus);
                }
                if (load.expenses) {
                  this.totalsCounts.totalExpenses += parseFloat(load.expenses);
                }
                this.totalsCounts.totalNet += parseFloat(load.net);
              } else {
                this.isWithNet = false;
              }

              this.loads.push(load);
            }
            this.totalsCounts.avgFeesPercent = parseFloat(parseFloat(sumOfFeesPercent / this.loads.length).toFixed(2));
            this.totalsCounts.loads = this.loads.length;
          }

          this.initHeaders();
          this.reportsGroupsListKey = 'reportsGroupsListKey' + new Date().getTime();
          this.onItemSelected();
          this.$forceUpdate();
          this.loading = false;
          resolve(this.totalsCounts);
        }).finally(() => {
          this.loading = false;
        });
      });
    }
  }
};
</script>
